module.exports = __webpack_public_path__ + "static/media/logo-pontonovo.70e3a190.png";